import React, {useState} from 'react';
import classnames from 'classnames';
import {FormattedHTMLMessage} from 'react-intl';
import Modal from '@ignitesales/react-modal';
import Input from '@ignitesales/react-input-debounced';
import {cssBEM} from './index.jsx';

const CardModal = props => {
  const {
    activeCard,
    closeModalBtn = <span>x</span>,
    onClose,
    onSave,
    nodeId='root',
    renderModalHeaderFn,
    renderModalBodyFn,
    renderQuestion,
    renderOptions,
    searchCallbackFn,
    searchInputLabel,
    searchInputPlaceholder,
    showSearchFilter
  } = props;

  const modalCssBem = 'cardBuilderModal';
  const classes = classnames(modalCssBem, {
    [`${modalCssBem}--select-option-mode`]: !activeCard,
    [`${modalCssBem}--edit-option-mode`]: activeCard,
  });

  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = value => {
    setSearchTerm(value);
    searchCallbackFn(value);
  };

  const renderHeader = () => {
    const defaultRender = <FormattedHTMLMessage id={ activeCard ? `${activeCard.id}.cardBuilder.title` : 'cardBuilder.modal.title'} />;
    return renderModalHeaderFn ? renderModalHeaderFn(activeCard) : defaultRender;
  };

  const renderBody = () => {
    return renderModalBodyFn ? renderModalBodyFn(activeCard) : null;
  };

  const renderSearch = () => {
    return <div className='cardBuilderModal__search-filter'>
      <label htmlFor="card-search">{searchInputLabel}</label>
      <Input
        id={'card-search'}
        type={'text'}
        onChange={handleChange}
        delay={300}
        placeholder={searchInputPlaceholder}
        value={searchTerm}
      />
    </div>;
  };

  const renderFooter = () => {
    const btnClass = activeCard ? `${cssBEM}__btn--saveCard` : `${cssBEM}__btn--cancelEdit`;
    const btnMessageId = activeCard ? 'cardBuilder.saveCard' : 'cardBuilder.cancelEdit';
    return <button type="button" className={ `${cssBEM}__btn ${btnClass}` } onClick={onSave} role="button" aria-label="Save or Edit Card">
      <FormattedHTMLMessage id={ btnMessageId } />
    </button>;
  };

  return (
    <Modal
      className={ `${cssBEM}__modal` }
      closeBtn={ closeModalBtn }
      nodeId={ nodeId }
      onClose={ onClose }
      show
    >
      <div className={classes}>
        <div className={`${modalCssBem}__header`}>
          { renderHeader() }
          { !activeCard && showSearchFilter ? renderSearch() : null }
        </div>
        <div className={`${modalCssBem}__questions`}>
          { activeCard ? activeCard.questions.map(question => renderQuestion(question)) : renderOptions() }
        </div>
        <div className={`${modalCssBem}__body`}>
          { renderBody() }
        </div>
        <div className={`${modalCssBem}__footer`}>{ renderFooter() }</div>
      </div>
    </Modal>
  );
};

export default CardModal;
